// extracted by mini-css-extract-plugin
export default {"dialog":"Share_dialog__xu24N"};